'use strict';

/* eslint no-undef: "off" */
/**
 * loading
 */
define('loading',['busEvent', 'jquery'], function (busEvent, $) {
  return {
    template: '\n      <div class="in-loading" v-if="isLoadingShow">\n      </div>\n    ',
    data: function data() {
      return {
        isLoadingShow: false
      };
    },
    mounted: function mounted() {
      this.showEvent();
      this.hideEvent();
    },

    methods: {
      /**
       * show event
       */
      showEvent: function showEvent() {
        var _this = this;

        busEvent.$on('loadingShowEvent', function () {
          _this.show();
        });
      },

      /**
       * hide event
       */
      hideEvent: function hideEvent() {
        var _this2 = this;

        busEvent.$on('loadingHideEvent', function () {
          _this2.hide();
        });
      },

      /**
       * show address modal
       */
      show: function show() {
        this.isLoadingShow = true;
      },

      /**
       * hide address modal
       */
      hide: function hide() {
        this.isLoadingShow = false;
      }
    }
  };
});
